<div style="margin: 10px;">
  <form [formGroup]="settingsForm">
    <div class="mb-3 row">
      <span class="col-lg-2">Agent Name:</span>
      <input class="col-lg-4" type="text" pInputText [formControl]="agentName" />
    </div>
    <div class="row">
      @if (agentName.hasError('required')) {
        <div class="col-lg-6 alert alert-danger">Agent Name is required</div>
      }
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">Agent Description:</span>
      <input class="col-lg-4" type="text" pInputText [formControl]="agentDesc" />
    </div>
    <div class="mb-3 row">
      <span class="col-2">Configuration Update Interval (minutes):</span>
      <input class="col-1" type="number" pInputText [formControl]="configInterval" />
      <info class="col-1" width="500px">How often this agent should contact the server for configuration updates</info>
    </div>
    <div class="row">
      @if (configInterval.hasError('required')) {
        <div class="col-lg-3 alert alert-danger">Configuration Update Interval is required</div>
      }
    </div>
    <div class="row">
      @if (configInterval.hasError('minValue') || configInterval.hasError('maxValue')) {
        <div class="col-lg-3 alert alert-danger">Configuration Update Interval must be in the range 1 - 1500</div>
      }
    </div>
    <div class="mb-3 row">
      <span class="col-2">Discovery Status Update Interval (seconds):</span>
      <input class="col-1" type="number" pInputText [formControl]="discStatusInterval" />
      <info class="col-1" width="500px">How often this agent should report discovery status to the server</info>
    </div>
    <div class="row">
      @if (discStatusInterval.hasError('required')) {
        <div class="col-lg-3 alert alert-danger">Discovery Status Update Interval is required</div>
      }
    </div>
    <div class="row">
      @if (discStatusInterval.hasError('minValue') || discStatusInterval.hasError('maxValue')) {
        <div class="col-lg-3 alert alert-danger">Discovery Status Update Interval must be in the range 15 - 3600</div>
      }
    </div>

    <div class="mb-3 form-check">
      <input type="checkbox" [formControl]="requireLogin" class="form-check-input" id="require-login">
      <label class="uv-checkbox-label" for="require-login">Require Login</label>
    </div>
  </form>
</div>
